import { z } from 'zod';

export const infoSectionSchema = z.object({
  heading: z.string().optional(),
  body: z.string().optional(),
  bullets: z.array(z.string()).optional(),
  link: z.string().optional()
}).refine(section => Boolean(section.body || (section.bullets && section.bullets.length > 0)), {
  message: 'Section must include either body text or at least one bullet point'
});

export const infoContentSchema = z.object({
  title: z.string(),
  updatedAt: z.string().optional(),
  sections: z.array(infoSectionSchema).min(1)
});

export type InfoSection = z.infer<typeof infoSectionSchema>;
export type InfoContent = z.infer<typeof infoContentSchema>;



